import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import {map} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Photo } from '../_models/photo';
import { User } from '../_models/user';
import { UserParams } from '../_models/userParams';
import { PresenceService } from './presence.service';

//const BASE_URL = 'https://localhost:5001/api/';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  baseUrl = environment.apiUrl;

private currentUserSource = new ReplaySubject<User>(1);
currentUser$ = this.currentUserSource.asObservable();

  constructor(private http: HttpClient, private presence: PresenceService) { }

  login(model: any){
    return this.http.post<User>(this.baseUrl + 'account/login', model).pipe(
      map((response: User) =>{
       const user = response;
        // console.log(user.userName);
        if (user){
          this.setCurrentUser(user);
          this.presence.createHubConnection(user);
        }
      })
    );
  }

  register(model: any){
    return this.http.post<User>(this.baseUrl + 'account/register', model).pipe(
      map((user: User) => {
        if(user){
          this.setCurrentUser(user);
          this.presence.createHubConnection(user);
        }
        return user;
      })
    )
  }

  // uploadPhoto(model: any){
  //   return this.http.post<Photo>(this.baseUrl + 'users/add-photo', model).pipe(
  //     map((photo: Photo) => {
  //       // if(photo){
  //       //   const a = JSON.stringify(photo);
  //       // }
  //       return photo;
  //     })
  //   )
  // }

  aUser: User = {
    userName:"",
    token: "",
    photoUrl:"",
    nickName:"",
    gender: "",
    roles: []
  }

  setCurrentUser(user: User){

    //if(user == null) user = this.aUser;

    user.roles = [];
    
    const roles = this.getDecodedToken(user.token).role;
    Array.isArray(roles) ? user.roles = roles : user.roles.push(roles);
    localStorage.setItem('user', JSON.stringify(user));
    this.currentUserSource.next(user)
  }

  logout(){
    localStorage.removeItem('user');
    this.currentUserSource.next(null!);
    this.presence.stopHunConnection();
  }

  getDecodedToken(token: string){
    return JSON.parse(atob(token.split('.')[1]));
  }
}
